<script setup lang="ts">
defineProps<{
  sizeGuide: any[]
  title?: string
  location?: string
}>()
</script>
<template>
  <div v-for="(content, index) in sizeGuide" :key="index" class="product-size-guide__content">
    <div v-for="(table, tableIndex) in content.table" :key="tableIndex" class="product-size-guide__table-container">
      <Table
        :table="table.fields.table"
        :variant="table.fields.supportingData?.home?.variant?.value || undefined"
        :under-table-text="table.fields.underTableText"
      />
    </div>
    <RichTextPanel :content="content.content" skip-container />
  </div>
</template>

<style lang="postcss">
.product-size-guide__content {
  .table.container {
    padding-inline: var(--space-00);
    margin-bottom: var(--space-60);

    .stacked-table__table {
      display: block;

      table {
        th,
        td {
          border: 1px solid var(--border-neutral-30);
          padding: var(--space-40) var(--space-30);
          font-size: var(--text-small);
        }
      }

      .table-cell__text {
        word-wrap: break-word;
      }
    }

    .stacked-table__list {
      display: none;
    }

    table tr:nth-child(odd) {
      background: #f6f6f6;
    }
  }
}
</style>
